module.exports = __webpack_public_path__ + "img/_1.00979be1.webp";